var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.3342V3.0013C10.6667 2.44681 10.6667 2.16956 10.5499 1.99918C10.4478 1.85032 10.2898 1.74919 10.1118 1.71892C9.90819 1.68426 9.65646 1.80044 9.153 2.03281L3.23934 4.76219C2.79034 4.96942 2.56583 5.07304 2.4014 5.23374C2.25604 5.37581 2.14508 5.54923 2.077 5.74075C2 5.95739 2 6.20465 2 6.69917V10.0009M11 9.66753H11.0067M2 7.46753L2 11.8675C2 12.6143 2 12.9876 2.14532 13.2728C2.27316 13.5237 2.47713 13.7277 2.72801 13.8555C3.01323 14.0009 3.3866 14.0009 4.13333 14.0009H11.8667C12.6134 14.0009 12.9868 14.0009 13.272 13.8555C13.5229 13.7277 13.7268 13.5237 13.8547 13.2728C14 12.9876 14 12.6143 14 11.8675V7.46753C14 6.72079 14 6.34742 13.8547 6.06221C13.7268 5.81133 13.5229 5.60735 13.272 5.47952C12.9868 5.3342 12.6134 5.3342 11.8667 5.3342L4.13333 5.3342C3.3866 5.3342 3.01323 5.3342 2.72801 5.47952C2.47713 5.60735 2.27316 5.81133 2.14532 6.06221C2 6.34742 2 6.72079 2 7.46753ZM11.3333 9.66753C11.3333 9.85162 11.1841 10.0009 11 10.0009C10.8159 10.0009 10.6667 9.85162 10.6667 9.66753C10.6667 9.48343 10.8159 9.3342 11 9.3342C11.1841 9.3342 11.3333 9.48343 11.3333 9.66753Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.19e7bda0456bc4733379aea1a9e4c187.svg";
export { ForwardRef as ReactComponent };